import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c('PlacesOfService',{on:{"changes":_vm.checkChanges}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }